import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-light border border-top p-1">
            <span>Crafted with ❤️ by Mohammad Nahiduzzaman</span>
        </footer>
    );
};

export default Footer;
